import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-DialogQB-portal" */'@modals/partials/QueryBuilder/DialogQB'));
